module.exports = __webpack_public_path__ + "img/logo-arena.02e03180.png";